import { useState } from "react";
import "react-quill-new/dist/quill.snow.css"; // Quill's default theme
import ReactQuill from "react-quill-new";
import { QuillDeltaToHtmlConverter } from "quill-delta-to-html";

export type QuillValue = {
  plaintext: string;
  html: string;
  _html: () => string; // Helper function that generates the final html without classes from quill
};

export const defaultQuillValue = () => ({
  plaintext: "",
  html: ``,
  _html: () => ""
});

export interface IQuillEditor
  extends Omit<React.ComponentProps<typeof ReactQuill>, "onChange" | "value"> {
  className?: string;
  value?: QuillValue;
  onChange?: (v: QuillValue) => void;
}

const QuillEditor = ({ className, value, onChange, ...props }: IQuillEditor) => {
  const [_value, setValue] = useState<QuillValue>(value || defaultQuillValue());

  const handleChange = (content, delta, source, editor) => {
    const converter = new QuillDeltaToHtmlConverter(editor.getContents().ops, {
      inlineStyles: true
    });
    const v = {
      html: content,
      _html: () => converter.convert(),
      plaintext: editor.getText().trim()
    };

    setValue(v);
    onChange?.(v);
  };
  return (
    <ReactQuill
      className={className}
      theme="snow"
      value={_value.html}
      onChange={handleChange}
      placeholder="Start typing..."
      modules={{
        toolbar: [
          [{ header: [1, 2, false] }],
          ["bold", "italic", "underline"],
          [{ list: "ordered" }, { list: "bullet" }],
          ["clean"]
        ]
      }}
      formats={["header", "bold", "italic", "underline", "list"]}
      {...props}
    />
  );
};

export default QuillEditor;
